module.exports = __webpack_public_path__ + "static/media/WomenInCSLogo.5e9ae3df.png";